import React from "react";
import { Box, Skeleton } from "@mui/material";

const GRID_COLUMNS = "48px 176px minmax(220px, 1fr) 116px 146px 142px 90px";
const GROUP_COUNT = 2;
const ROWS_PER_GROUP = 4;

const SkeletonBar = ({ width = "100%", height = 16 }) => (
  <Skeleton variant="rounded" animation="wave" width={width} height={height} />
);

const SkeletonRow = () => (
  <Box
    sx={{
      minHeight: "52px",
      px: 1.5,
      display: "grid",
      gridTemplateColumns: GRID_COLUMNS,
      alignItems: "center",
      columnGap: 2,
    }}
  >
    <Skeleton
      variant="circular"
      animation="wave"
      width={20}
      height={20}
      sx={{ mx: "auto" }}
    />
    <SkeletonBar width="40%" />
    <SkeletonBar width="70%" />
    <SkeletonBar width="50%" />
    <SkeletonBar width="60%" />
    <SkeletonBar width="60%" />
    <SkeletonBar width="40%" />
  </Box>
);

const SkeletonGroup = () => (
  <Box
    sx={{
      border: "1px solid #DDDDDD",
      borderRadius: "8px",
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        minHeight: "46px",
        px: 1.5,
        display: "grid",
        gridTemplateColumns: "48px 1fr 40px",
        alignItems: "center",
        columnGap: 2,
      }}
    >
      <Skeleton
        variant="circular"
        animation="wave"
        width={20}
        height={20}
        sx={{ mx: "auto" }}
      />
      <SkeletonBar width="180px" height={20} />
      <Skeleton variant="circular" animation="wave" width={24} height={24} />
    </Box>

    <Box
      sx={{
        minHeight: "36px",
        px: 1.5,
        display: "grid",
        gridTemplateColumns: GRID_COLUMNS,
        alignItems: "center",
        columnGap: 2,
        bgcolor: "#F7F7F7",
        borderTop: "1px solid #DDDDDD",
        borderBottom: "1px solid #DDDDDD",
      }}
    >
      <Box />
      <SkeletonBar width="60%" height={14} />
      <SkeletonBar width="30%" height={14} />
      <SkeletonBar width="50%" height={14} />
      <SkeletonBar width="60%" height={14} />
      <SkeletonBar width="60%" height={14} />
      <SkeletonBar width="50%" height={14} />
    </Box>

    {Array.from({ length: ROWS_PER_GROUP }, (_, index) => (
      <SkeletonRow key={index} />
    ))}
  </Box>
);

const CultureHubModalSkeleton = () => (
  <>
    <Box
      component="span"
      role="status"
      aria-live="polite"
      sx={{
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: 0,
      }}
    >
      Carregando dados do projeto…
    </Box>

    <Box
      aria-hidden="true"
      sx={{ display: "flex", flexDirection: "column", gap: 3 }}
    >
      <Box
        sx={{
          minHeight: "40px",
          px: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Skeleton variant="circular" animation="wave" width={20} height={20} />
        <SkeletonBar width="120px" />
        <SkeletonBar width="190px" height={30} />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {Array.from({ length: GROUP_COUNT }, (_, index) => (
          <SkeletonGroup key={index} />
        ))}
      </Box>
    </Box>
  </>
);

export default CultureHubModalSkeleton;
